
export const SEARCH_ORDERS_URL = "/api/admin/order/by/customerId";
export const SEARCH_INVOICES_URL = "/api/admin/invoice/by/customerId";

export const UPDATE_ORDER_STATUS_URL = "/api/admin/order/update/status"

export const BUSINESS_DETAILS_URL = "/api/customer/details";

export const CHANGE_AUTH_CONTEXT_URL = "/api/auth/admin/change/login";

export const FETCH_NEWS_URL = "/api/customer/info/whatsnews";
export const FETCH_GREETINGS_URL = "/api/customer/info/greetings";

export const FETCH_TESTIMONIALS_URL = "/api/customer/testimony";
export const CREATE_TESTIMONIAL_URL = "/api/admin/customer/testimony/add-edit";
export const TESTIMONIAL_DELETE_URL = "/api/admin/customer/testimony/remove";

export const FETCH_SERVICES_URL = "/api/customer/service";
export const CREATE_SERVICE_URL = "/api/admin/customer/service";

export const DASHBOARD_FINANCIAL_ORDER_SALES_YEARLY_URL = "/api/dashboard/order/financial/year/order-sales";
export const DASHBOARD_FINANCIAL_ORDER_SALES_TODAY_URL = "/api/dashboard/order/today/order-sales"

export const DASHBOARD_ORDERS_TREND_WEEK_URL = "/api/dashboard/order/week/day-wise/order-sales";
export const DASHBOARD_ORDERS_TREND_MONTH_URL = "/api/dashboard/order/month/day-wise/order-sales";

export const CREATE_ATTRIBUTE = "/api/admin/catalog/products/attribute";
export const DELETE_ATTRIBUTE = "/api/admin/catalog/products/delete/attribute";

export const FETCH_ISSUES_URL = "/api/order/ondc/issues";
export const FETCH_ISSUE_URL = "/api/order/ondc/issue-details";
export const FETCH_ISSUES_RESOLUTION_TYPES_URL = "/api/master/resolution-types";
export const FETCH_ISSUES_ACTION_TYPES_URL = "/api/master/action-types";
export const UPDATE_ISSUES_ACTIONS_URL = "/api/order/ondc/issue-action";
export const FETCH_ISSUES_INFO_TYPES_URL = "/api/master/info-types";
export const CREATE_ONDC_ISSUE_URL="/api/ondc-order/create/issue";
export const FETCH_ONDC_SERVER_TYPES_URL="/api/ondc-order/server/types";

export const FETCH_SETTLEMENT_URL = "/api/ondc-order/un-settled/list";
export const CREATE_SETTLEMENT = "/api/ondc-order/settle";
export const GET_ROLE = "/api/ondc-order/np/ondc/roles";
export const GET_PARTY_BASED_ROLE = "/api/ondc-order/np/list/for/selected/role";
export const GET_SETTLEMENT_TYPE = "/api/ondc-order/settlement/types";
export const GET_LIST_OF_ORDER = "/api/ondc-order/order/list/for/np/to/settle";
export const FETCH_UNSETTLED_LIST = "/api/ondc-order/un-settled/list";
export const GET_REPORT = "/api/ondc-order/report";

export const GET_LIST_DISCREPANCY = "api/ondc-order/np/list/for/other/party/discrepency";
export const LIST_WITH_DISCREPANCY = "api/ondc-order/un-settled/list";
export const RECONCILE_URL = "api/ondc-order/mperito/recon";
export const RECONCILE_STATUS_URL = "api/ondc-order/un-settled/recon/list";
export const OTHER_PARTY_RECONCILE_STATUS_URL = "api/ondc-order/np/list/for/other/party/reconcillation";
export const RECONCILE_LIST_URL = "api/ondc-order/un-settled/recon/list";
export const RECONCILE_STATUS_POST_URL = "api/ondc-order/mperito/recon";
export const EDIT_SETTLEMENT = "api/ondc-order/update/settlement";
export const GET_STATUS = "/api/ondc-order/settlement/status/types";
export const GET_ONDC_ORDER_URL = "/api/ondc-order/ondc/orders";
export const EDIT_ORDER = "/api/ondc-order/update/status";
export const GET_TYPE = "/api/ondc-order/fulfillment/status/types";
export const GET_RETURN_TYPE = "/api/ondc-order/return/fulfillment/status/types";
export const GET_RETURN_ORDER_LIST = "/api/ondc-order/return/orders";
export const RETURN_ORDER_EDIT = "/api/ondc-order/update/return/status";



// /api/admin/customer/testimony/add-edit [POST]
// /api/admin/customer/testimony/remove?testimonyId=7 [DELETE]
// /api/admin/customer/service [POST]
// /api/admin/customer/service [DELETE]



